<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
    <div class="flex-s-c">
      <span class="key">讲解日期：</span>
      <span class="value">{{currentContent.explainDate}}（星期{{weekDay}}）</span>
    </div>
    <div class="flex-s-fs mat10">
      <span class="key">讲解时间：</span>
      <span class="value">
        <el-checkbox-group v-model="checkList">
          <el-checkbox :disabled="item.volunteerName!==null" :label="item.taskId" v-for="item in currentContent.explainInfoList">
            <span class="time">{{item.explainTime}}</span><span>{{item.volunteerName}}</span>
          </el-checkbox>

        </el-checkbox-group>
      </span>
    </div>
    <!-- <div class="flex-s-c mat10" v-if="edit">
      <span class="key">就餐申请：</span>
      <span class="value">
        <el-switch v-model="eat" active-color="#007083" inactive-color="#A5ACBE">
        </el-switch>
      </span>
    </div> -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitDialog" size="small" v-if="edit">确 定</el-button>
      <el-button @click="closeDialog" size="small" plain>取 消</el-button>

    </span>
  </el-dialog>
</template>

<script>
import { formatDate } from '@/libs/utils'
export default {
  components: {},
  props: {
    dialogVisible: {
      //弹窗组件是否显示 默认不显示
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      //弹窗标题
      type: String,
      default: '标题',
      required: true,
    },
    edit: {
      //是否编辑
      type: Boolean,
      default: false,
      required: true,
    },
    currentContent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkList: [],
      eat: false,
      weekDay: ""
    };
  },
  computed: {},
  watch: {
    currentContent() {
      this.weekDay = formatDate(this.currentContent.explainDate, 4)
    }
  },
  methods: {
    handleClose(done) {
      this.checkList = []
      this.$emit("on-close");
    },
    submitDialog() {
      if (this.checkList.length == 0) {
        this.$message.error("请选择报名时间");
      } else {
        let params = {
          checkList: this.checkList,
          date: this.currentContent.explainDate
        }
        this.checkList = []
        this.$emit("on-submit", 'explain', params);
        this.$emit("on-close");
      }
    },
    closeDialog() {
      this.checkList = []
      this.$emit("on-close");
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // console.log(this.currentContent)
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "./modal.less";
</style>
